import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {RoomPartyWithoutPrimaryOccupant} from '../../../graphql/groups.datatypes';
import {gqlRoomParty} from '../../RoomParty/getRoomParty.api';


interface RoomPartiesData {
    roomPartiesNoPrimaryOccupant: RoomPartyWithoutPrimaryOccupant[];
}

export const GET_ROOM_PARTIES_NO_PRIMARY_OCCUPANT_QUERY = gql`
  query getRoomPartiesNoPrimaryOccupant($group_id: Int){
    roomPartiesNoPrimaryOccupant(group_id: $group_id) {
        id
        group_name
        primary_occupant
        date_booked
        members_count
    }
  }
`;

export const getRoomPartiesNoPrimaryOccupant = (groupId?: number) => useQuery<RoomPartiesData>(
    GET_ROOM_PARTIES_NO_PRIMARY_OCCUPANT_QUERY,
    {
        variables: {
            group_id: groupId,
        },
    }
);

export default getRoomPartiesNoPrimaryOccupant;
